<div class="sidebar" (mouseenter)="menuOpen()" (mouseleave)="menuClose()">
  <ul class="sidebar-menu">
    <ng-container *ngIf="acessoMenuUsuario?.basicoMenu">
      <li class="sidebar-item" routerLink="/app/disparos" (click)="itemSelected('disparos')" [ngClass]="{'active': menuSelected === 'disparos'}">
        <a >
          <mat-icon class="icon">send</mat-icon>
          <span class="text">Disparos</span>
        </a>
      </li>
    </ng-container>
   <ng-container *ngIf="acessoMenuUsuario?.agendaMenu">
      <li class="sidebar-item" routerLink="/app/agendas" (click)="itemSelected('agenda')" [ngClass]="{'active': menuSelected === 'agenda'}">
        <a >
          <mat-icon class="icon">event</mat-icon>
          <span class="text" >Agendas</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="acessoMenuUsuario?.basicoMenu">
      <li class="sidebar-item" routerLink="/app/listas"  (click)="itemSelected('listas')" [ngClass]="{'active': menuSelected === 'listas'}">
        <a >
          <mat-icon class="icon">list</mat-icon>
          <span class="text">Listas</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="acessoMenuUsuario?.basicoMenu">
      <li class="sidebar-item" routerLink="/app/nutricoes" (click)="itemSelected('nutricoes')" [ngClass]="{'active': menuSelected === 'nutricoes'}">
        <a>
          <mat-icon class="icon">polyline</mat-icon>
          <span class="text">Nutrições</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="acessoMenuUsuario?.basicoMenu">
      <li class="sidebar-item" routerLink="/app/mensagens" (click)="itemSelected('messages')" [ngClass]="{'active': menuSelected === 'messages'}">
        <a>
          <mat-icon class="icon">chat</mat-icon>
          <span class="text">Mensagens</span>
        </a>
      </li>

    </ng-container>
    <ng-container *ngIf="acessoMenuUsuario?.basicoMenu">
      <li class="sidebar-item" routerLink="/app/canais" (click)="itemSelected('canais')" [ngClass]="{'active': menuSelected === 'canais'}">
        <a>
          <mat-icon class="icon">link</mat-icon>
          <span class="text">Canais</span>
        </a>
      </li>
    </ng-container>

    <ng-container *ngIf="acessoMenuUsuario?.basicoMenu">
      <li class="sidebar-item" routerLink="/app/bloqueados" (click)="itemSelected('bloqueados')" [ngClass]="{'active': menuSelected === 'bloqueados'}">
        <a>
          <mat-icon class="icon">block</mat-icon>
          <span class="text">Bloqueados</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="acessoMenuUsuario?.clinicorpMenu">
      <li class="sidebar-item" routerLink="/app/clinicorp-menu" (click)="itemSelected('clinicorp-menu')" [ngClass]="{'active': menuSelected === 'clinicorp-menu'}">
        <a>
          <mat-icon class="icon">local_hospital</mat-icon>
          <span class="text">Clinicorp</span>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="acessoMenuUsuario">
    <ng-container *ngIf="acessoMenuUsuario.ekuroMenu">
      <li class="sidebar-item" routerLink="/app/ecuro" (click)="itemSelected('ecuro')" [ngClass]="{'active': menuSelected === 'ecuro'}">
        <a>
          <mat-icon class="icon">lan</mat-icon>
          <span class="text">Ecuro Integracao</span>
        </a>
      </li>

    </ng-container>
    </ng-container>

    <ng-container>
      <li class="sidebar-item" routerLink="/app/perfil" (click)="itemSelected('perfil')" [ngClass]="{'active': menuSelected === 'perfil'}">
        <a>
          <mat-icon class="icon">person</mat-icon>
          <span class="text">Perfil</span>
        </a>
      </li>
    </ng-container>
  </ul>

  <div class="logout-section">
    <a class="logout-btn" (click)="logout()">
      <mat-icon class="icon">logout</mat-icon>
      <span class="text">Sair</span>
    </a>
  </div>
  <div class="version-section">
    Versao {{version}}
  </div>
</div>
